import { useState, useCallback, useEffect } from "react";
import { VideoBlock } from "./Items/VideoBlock";
import { ImageBlock } from "./Items/ImageBlock";
import { TextBlock, MathTextBlock } from "./Items/TextBlock";
import { LocalVideoBlock } from "./Items/LocalVideoBlock";
import { LinkBlock } from "./Items/LinkBlock";
import { useQuestions } from "../QuestionStore";
import OptionWrapper from "../../Test/Utility/OptionWrapper";
import { SolutionBlock } from "./Items/SolutionBlock";
// ─────────────────────────────────────────────
// Dummy data list
// ─────────────────────────────────────────────
const DUMMY_ITEMS = [
  {
    ind: 0,
    media: "video",
    res: { url: "https://www.youtube.com/embed/RyNjg4Qeqmk", local: false },
  },
  {
    ind: 1,
    media: "image",
    res: {
      url: "https://plus.unsplash.com/premium_photo-1773763010999-abc4d9b7e0f7?q=80&w=829&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      local: false,
    },
  },
  {
    ind: 2,
    media: "text",
    res: {
      text: "The universe is under no obligation to make sense to you. Every atom in your body came from a star that exploded. You are literally stardust.",
      size: "md",
    },
  },
  {
    ind: 3,
    media: "video",
    res: { url: "https://www.youtube.com/embed/aqz-KE-bpKQ", local: false },
  },
  {
    ind: 4,
    media: "image",
    res: {
      url: "https://images.unsplash.com/photo-1469474968028-56623f02e42e?w=800",
      local: false,
    },
  },
  {
    ind: 5,
    media: "text",
    res: {
      text: "Short note.",
      size: "sm",
    },
  },
];




// ─────────────────────────────────────────────
// Block dispatcher
// ─────────────────────────────────────────────
function Block({ item, onDelete, width, onSelect, selectedInd }) {
  const props = { item, onDelete, width };
  const hasMcq = item.res?.mcq != null;
  const label = hasMcq ? `Option ${item.res.mcq}` : "";
  const isSelected = selectedInd === item.ind;

  const inner =
    item.media === "video"
      ? item.res.local
        ? <LocalVideoBlock {...props} />
        : <VideoBlock {...props} />
      : item.media === "image"
        ? <ImageBlock {...props} />
        : item.media === "text"
          ? item.res.math
            ? <MathTextBlock {...props} />
            : <TextBlock {...props} />
          : item.media === "link"
            ? <LinkBlock {...props} />
            : null;

  // Fix 3: only wrap if mcq field present
  if (hasMcq) {
    return (
      <OptionWrapper
        label={label}
        isSelected={isSelected}
        onSelect={() => onSelect?.(item.ind)}
      >
        {inner}
      </OptionWrapper>
    );
  }

  return inner;
}

// ─────────────────────────────────────────────
// LeftPanelContent
// ─────────────────────────────────────────────
export default function LeftPanelContent({ panelWidth }) {
  const MARGIN = 24;
  const blockWidth = (panelWidth ?? 320) - MARGIN * 2;

  const { questions, selectedItem, deleteItemFromCurrentQuestion, } = useQuestions();
  const [selectedInd, setSelectedInd] = useState(null);

  // read directly — always live, never stale
  const items = questions[selectedItem]?.items ?? [];

  const handleDelete = (id) => deleteItemFromCurrentQuestion(id);

  // Sorted by ind
  const sorted = [...items].sort((a, b) => a.ind - b.ind);
  console.log("rendering, sorted:", sorted, "selectedItem:", selectedItem, "questions:", questions);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",
        boxSizing: "border-box",
        background: "#f7f7f8",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          padding: `${MARGIN}px`,
          boxSizing: "border-box",
          minHeight: "100%",        // ← ensures it fills even when few items
        }}
      >
        {sorted.length === 0 && (
          <p style={{ color: "#aaa", fontSize: 14, textAlign: "center", marginTop: 40 }}>
            No Content.
          </p>
        )}

        {sorted.map(item => (
          <Block
            key={item.ind}
            item={item}
            width={blockWidth}
            onDelete={() => handleDelete(item.ind)}
            onSelect={(ind) => setSelectedInd(ind)}
            selectedInd={selectedInd}
          />
        ))}

        <SolutionBlock />
      </div>
    </div>
  );
}